// Return some info about the active tab.

import get from 'lodash/get'

import { CONFIG_DRAWER_TAB_ACTIVE_PATH, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED } from 'api/actions'

export default function GetActiveTabInfo () {
  const state = window.store.getState()
  const activeTabId = get(state, 'config.' + CONFIG_DRAWER_TAB_ACTIVE_PATH, '')
  const searchDirectionsExpanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, false)
  const searchFindExpanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED, false)

  return {
    activeTabId,
    searchDirectionsExpanded,
    searchFindExpanded
  }
}
